import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const DialogBody = (_a) => {
    var { className, children } = _a, remainingProps = __rest(_a, ["className", "children"]);
    const classes = classNames('modal-body', className);
    return (_jsx("div", Object.assign({}, remainingProps, { className: classes }, { children: children })));
};
DialogBody.defaultProps = {
    className: '',
};
DialogBody.propTypes = {
    className: PropTypes.string,
};
export default DialogBody;
